export const ALREADY_EXISTS = "AlreadyExists";
export const END_DATE_REQUIRED = "end_date_required";
export const ERROR_EDIT_MISSION_BILL = "an_error_occured";
export const FIELD_REQUIRED = "field_required";
export const GENERIC_ERROR = "an_error_occured";
export const LEAVING_REASON_REQUIRED = "leaving_reason_required";
export const MUTATION_NEW_CONTRACT_REQUIRED = "mutation_new_contract_required";
export const NOT_FOUND = "NotFound";
export const SIREN_ALREADY_EXISTS = "siren_already_exist";
export const SIREN_NOT_FOUND = "siren_not_found";
export const SIREN_REQUEST_ERROR = "no_result_siren_request";
export const SUCCESS_EDIT = "success_edit";
export const SUCCESS_EDIT_MISSION_BILL = "success_edit_mission_bill";
export const CONTRACT_CHANGE_NEW_CONTRACT_REQUIRED =
  "contract_change_new_contract_required";
export const THREE_CHARACTERS_MINI = "three_characters_mini";
export const EMPTY_SEARCH_FIELD_ERROR = "empty_search_field_error";
export const SUCCESS_ADD_PROSPECTION = "success_add_prospection";
export const ERROR_UPLOAD_FILE_SIZE = "error_upload_file_size";
export const ERROR_UPLOAD_FILE_TYPE = "error_upload_file_type";
export const ERROR_UPLOAD_MISSING_FILE = "error_upload_missing_file";
export const SUCCESS_IMPORTED_FILE = "success_imported_file";
export const SUCCESS_IMPORTED_FILE_WITH_ERRORS =
  "success_imported_file_with_errors";
export const ERROR_INVALID_EXCEL_FILE = "invalid_excel_file";
export const ERROR_INVALID_SIZE_EXCEL_FILE = "invalid_size_excel_file";
export const ERROR_UPLOAD_FILE = "error_upload_file_over_5mo";
export const ERROR_DATES = "error_dates";
export const ERROR_ONE_CONTRACT = "error_one_contract";
export const ERROR_JOB_HISTORY = "error_job_field_required";
export const ERROR_JOB_HISTORY_MISSING = "error_job_history_missing";
export const ERROR_MISSION_JOB = "error_mission_job";
export const ERROR_AT_LEAST_ONE_CONTRACT = "error_at_least_one_contract";
export const ERROR_AT_LEAST_ONE_SALARY = "error_at_least_one_salary";
export const ERROR_AT_LEAST_ONE_COEF = "error_at_least_one_coef";
export const ERROR_MISSING_SALARY_OR_ESTABLISHMENT_DATE =
  "error_missing_salary_or_establishment_date";
export const ERROR_SALARY_ESTABLISHMENT_DATE =
  "error_salary_establishment_date";
export const ERROR_MISSION_STATUS = "error_mission_status";
export const ERROR_ADD_JOB = "error_add_job";
export const END_DATE_AND_REASON_REQUIRED = "end_date_and_reason_required";
export const LAST_CONTRACT_LEAVING_REASON_END_DATE_REQUIRED =
  "last_contract_leaving_reason_end_date_required";
export const ERROR_DATE_FEE_BEFORE = "error_date_fee_before_mission_start";
export const ERROR_DATE_FEE_AFTER = "error_date_fee_after_mission_end";
export const ERROR_FEE_NUM = "error_fee_num";
export const ERROR_FEE_MISSING_DATE = "error_fee_missing_date_or_fee_value";
export const ERROR_HISTORY_MANAGERS_MISSING_INPUT =
  "error_history_managers_missing_manager_or_date_value";
export const ERROR_HISTORY_MANAGERS_ESTABLISHMENT_DATE_BEFORE_MISSION_START =
  "error_date_fee_before_mission_start";
export const ERROR_HISTORY_MANAGERS_ESTABLISHMENT_DATE_AFTER_MISSION_END =
  "error_date_fee_after_mission_end";
export const ERROR_HISTORY_COMPANY_HISTORY_MISSING_INPUT =
  "error_history_company_missing_subcontractor_company_or_date_value";
export const ERROR_HISTORY_MANAGERS_OUT_OF_MANAGER_CONCTRACT_ESTABLISHMENT_DATE =
  "error_history_managers_out_of_manager_contract_establishment_date";
export const ERROR_MISSING_FIELDS = "error_missing_fields";
export const ERROR_DATE_TIMING = "error_date_timing";
export const BRANCH_ID_REQUIRED = "branch_id_required";
export const ERROR_REQUIRED_DATES = "error_required_dates";
export const ERROR_INCONSISTENT_DATES = "error_inconsistent_dates";
export const ONE_FIELD_IS_MANDATORY = "one_field_is_mandatory";
export const THREE_CHARACTERS_MINI_MISSION_NAME =
  "three_characters_mini_mission_name";
export const COPY_EMAIL_SUCCESS = "copy_email_success";
export const DELIVERY_NOTE_COLUMN_REQUIRED = "delivery_note_column_required";
export const DELIVERY_NOTE_TEMPLATE_NAME_ALREADY_EXISTS =
  "delivery_note_template_name_already_exists";
export const DELIVERY_NOTE_TEMPLATE_NOT_FOUND =
  "delivery_note_template_not_found";
export const DELIVERY_NOTE_IMAGE_IMPORT_FAILED =
  "delivery_note_image_import_failed";
export const DELIVERY_NOTE_TEMPLATES_LOAD_ERROR =
  "delivery_note_templates_load_error";
export const DELIVERY_NOTE_LINE_REQUIRED = "delivery_note_line_required";
export const DELIVERY_NOTE_NUMBER_ERROR = "delivery_note_number_error";
export const DELIVERY_NOTE_PDF_ERROR = "delivery_note_pdf_error";
export const DELIVERY_NOTE_CURRENCY_LOAD_ERROR =
  "delivery_note_currency_load_error";
export const DELIVERY_NOTE_TEMPLATE_FAVORITE_ERROR =
  "delivery_note_template_favorite_error";
export const DELIVERY_NOTE_TEMPLATE_PUBLIC_ERROR =
  "delivery_note_template_public_error";
